module.exports = __webpack_public_path__ + "static/media/hallbart.45274ea0.png";